import { mergeAttributes } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { VueNodeViewRenderer } from '@tiptap/vue-3';

import AttachmentImageNode from './AttachmentImageNode.vue';

/**
 * Drop-in replacement for the stock Image node (same `image` name, so existing
 * documents keep working and UEditor's markdown pipeline is unaffected —
 * register it with `:image="false"` on UEditor to avoid a duplicate).
 *
 * Images uploaded through the editor carry a `fileId` and serialize their
 * `src` as the stable sentinel `dt-file://<fileId>` — presigned URLs must
 * never end up in persisted payloads. External images (plain `src`, no
 * `fileId`) render unchanged.
 */
export const AttachmentImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fileId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-file-id'),
        renderHTML: (attributes) => (attributes.fileId ? { 'data-file-id': attributes.fileId } : {}),
      },
      uploadId: {
        default: null,
        renderHTML: () => ({}),
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const attributes = node.attrs.fileId
      ? { ...HTMLAttributes, src: `dt-file://${node.attrs.fileId}` }
      : HTMLAttributes;

    return ['img', mergeAttributes(this.options.HTMLAttributes, attributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(AttachmentImageNode);
  },
});
